import React, { Component } from 'react';
import { Guardian } from '@xaamin/guardian';

import { Auth } from '../../support';
import UserProfile from './UserProfile';
import UserPassword from './UserPassword';

class Profile extends Component {

  handleOnUserProfileUpdate = (data) => {
    const prev = Auth.getData();

    Auth.setData({
      ...prev,
      user: { ...data }
    });
  }

  componentDidMount() {
    window.setAppTitle('Perfil');
  }

  render() {
    return (
      <>
        <div className="mb-4">
          <strong className="text-info">INFORMACIÓN PERSONAL</strong>
        </div>

        <UserProfile
          onComplete={ this.handleOnUserProfileUpdate }
        />

        <div className="py-4"></div>

        { Guardian.allows('perfil.cambiar.contraseña') && (
          <>
            <div className="mb-4">
              <strong className="text-info">CAMBIAR CONTRASEÑA</strong>
            </div>

            <UserPassword
              onComplete={ this.handleOnUserPasswordUpdate }
            />
          </>
        )}
      </>
    )
  }
}

export default Profile;